import axios from "axios";
import { ListAllPoetDTO } from "../../dto";
import { plainToClass } from "class-transformer";
import { validate } from "class-validator";

let body: ListAllPoetDTO;

export async function listAllPoetAction() {
  const token = localStorage.getItem("token");

  return await axios
    .get(`${process.env.REACT_APP_API_ORIGIN}/1.0.0/cms/poets/list-all`, {
      headers: {
        "Content-Type": "application/json",
        "app-platform": "cms",
        Authorization: `Bearer ${token}`,
      }
    })
    .then(async (res) => {
      body = plainToClass(ListAllPoetDTO, res.data);
      const errors = await validate(body);

      if (errors.length > 0) {
        throw errors;
      }

      return res.data;
    });
}
